import { Settings2 } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { Button } from '@/components/ui/button'
import {
  Sheet,
  SheetContent,
  SheetDescription,
  SheetHeader,
  SheetTitle,
  SheetTrigger,
} from '@/components/ui/sheet'
import { RegulatoryNewsSettingsPanel } from './RegulatoryNewsSettingsPanel'

type NewsroomSettingsSheetProps = {
  open: boolean
  onOpenChange: (open: boolean) => void
}

export function NewsroomSettingsSheet({
  open,
  onOpenChange,
}: NewsroomSettingsSheetProps) {
  const { t } = useTranslation('regulatory-alerts')

  return (
    <Sheet open={open} onOpenChange={onOpenChange}>
      <SheetTrigger asChild>
        <Button variant='outline' size='sm' className='gap-2'>
          <Settings2 className='size-4 shrink-0' aria-hidden />
          {t('page.openSettings')}
        </Button>
      </SheetTrigger>
      <SheetContent
        side='right'
        className='flex w-full flex-col gap-0 sm:max-w-md'
      >
        <SheetHeader className='border-b'>
          <SheetTitle>{t('settings.title')}</SheetTitle>
          <SheetDescription>{t('settings.description')}</SheetDescription>
        </SheetHeader>
        <div className='min-h-0 flex-1 overflow-y-auto'>
          <RegulatoryNewsSettingsPanel />
        </div>
      </SheetContent>
    </Sheet>
  )
}
